import { addMonths, isAfter, isBefore, startOfDay } from 'date-fns'
import parseISO from 'date-fns/parseISO'
import { createValidator, required, richTextMaxLength } from 'util/validation'

import { medicoesPanelValidator } from '../components/MedicoesPanel/validator'
import { AgendarConsultaPanelModel } from '../detail/soap/desfecho/components/AgendarConsultaPanel'
import { EscutaInicialState } from './model'
import { MotivoConsultaFormModel } from './motivo-consulta/MotivoConsultaForm'

export const escutaInicialValidator = (isPreAtendimento: Boolean) =>
  createValidator<EscutaInicialState>(
    {
      motivoConsulta: motivoConsultaValidator,
      medicoes: medicoesPanelValidator,
      agendarConsulta: agendarConsultaValidator,
    },
    (values: EscutaInicialState, errors) => {
      if (!isPreAtendimento) errors.classificacaoRisco = required(values.classificacaoRisco)

      return errors
    }
  )

const motivoConsultaValidator = createValidator<MotivoConsultaFormModel>({
  ciap: [required],
  texto: [richTextMaxLength(4000)],
})

export const agendarConsultaValidator = createValidator<AgendarConsultaPanelModel>({}, (values, error) => {
  if (values?.lotacao) {
    error.data = required(values.data)

    if (isAfter(parseISO(values?.data), addMonths(new Date(), 6))) {
      error.data = 'Não é permitido agendar para data superior a 6 meses'
    } else if (isBefore(parseISO(values?.data), startOfDay(new Date()))) {
      error.data = 'Não é permitido agendar para data anteriores à data atual'
    }

    if (!error.data) {
      error.horario = { inicial: required(values.horario?.inicial) }
    }
  }

  return error
})
